import NewGameModal from "./NewGameModal";
import LoadGameModal from "./LoadGameModal";
import { useEffect, useRef, useState } from "react";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import "./Start.scss";
import Tower from "../../images/tower.png";
import AllDataClass from "pages/common/AllDataClass";
import { useTranslation } from "react-i18next";

const Start = (): JSX.Element => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [openLoadGame, setOpenLoadGame] = useState(false);
  const [showLoading, setShowLoading] = useState(true);
  const handleClose = () => setOpen(false);
  const handleCloseLoadGame = () => setOpenLoadGame(false);

  useEffect(() => {
    const timer = setTimeout(() => setShowLoading(false), 700);
  }, []);
  const handleGo = () => {
    setOpen(false);
    navigate("/howtoplay");
  };
  const handleGoLoadGame = () => {
    setOpen(false);
    navigate("/howtoplay");
  };

  return (
    <div className="start-main-root">
      <NewGameModal open={open} handleClose={handleClose} handleGo={handleGo} />
      <LoadGameModal
        open={openLoadGame}
        handleClose={handleCloseLoadGame}
        handleGo={handleGoLoadGame}
      />
      <div className="game-title">{t("gamename")}</div>
      {showLoading === false && (
        <div className="absolute-wrap">
          <div className="buttons-wrap">
            <div
              className="start-button"
              onClick={() => {
                AllDataClass.clearAlldata(t("lang"));
                setOpen(true);
              }}
            >
              {t("button-newgame")
                .split("\n")
                .map((item: any, idx: any) => (
                  <span key={idx}>
                    {item}
                    <br />
                  </span>
                ))}
            </div>
            <div
              className="sub-button about"
              onClick={() => {
                console.log("about");
                navigate("/about");
              }}
            >
              {t("faq")
                .split("\n")
                .map((item: any, idx: any) => (
                  <span key={idx}>
                    {item}
                    <br />
                  </span>
                ))}
            </div>
            <div
              className="sub-button demo"
              onClick={() => {
                // window.open("https://youtu.be/yaosUp5n8eU", "_blank");
                // console.log("demo");
                navigate("/demo");
              }}
            >
              {t("demo")
                .split("\n")
                .map((item: any, idx: any) => (
                  <span key={idx}>
                    {item}
                    <br />
                  </span>
                ))}
            </div>
            <div
              className="sub-button loadgame"
              onClick={() => {
                console.log("demo");
                setOpenLoadGame(true);
              }}
            >
              {t("loadgame")
                .split("\n")
                .map((item: any, idx: any) => (
                  <span key={idx}>
                    {item}
                    <br />
                  </span>
                ))}
            </div>
            <div
              className="sub-button compare"
              onClick={() => {
                console.log("demo");
                navigate("/compare");
              }}
            >
              {t("compare")
                .split("\n")
                .map((item: any, idx: any) => (
                  <span key={idx}>
                    {item}
                    <br />
                  </span>
                ))}
            </div>
          </div>
        </div>
      )}
      {showLoading && <div className="loading">{t("loading")}</div>}
      <div className="license">
        <div className="title">
          {t("produce")} :&nbsp;
          <a href="https://perikorea.org" target="_blank" rel="noreferrer">
            {t("PERI")}
          </a>
          {t("lang") == "ko" && (
            <>
              &nbsp;&nbsp;|&nbsp; {t("sponsor")} :&nbsp;
              {/* 브루킹스 링크는 일단 표시하지 않음
              <a href="https://www.brookings.edu/" target="_blank" rel="noreferrer">
                BROOKINGS Institution
              </a>
              ,&nbsp; */}
              <a href="https://futurethinking.kr/" target="_blank" rel="noreferrer">
                {t("futurethinking")}
              </a>
            </>
          )}
        </div>
        <div>
          This game is based on The Fiscal Ship (
          <a href="https://fiscalship.org" target="_blank" rel="noreferrer">
            www.fiscalship.org
          </a>
          ), a product of the Hutchins Center on Fiscal and Monetary Policy at the Brookings
          Institution and the Wilson Center. The Fiscal Ship is licensed under Creative Commons{" "}
          <a href="https://creativecommons.org/licenses/by-nc-nd/4.0/" target="blank">
            CC BY-NC-ND 4.0
          </a>
          . This game is an adaptation created solely by PERI. Neither Brookings nor the Wilson
          Center endorses any of the content herein.
        </div>
      </div>
    </div>
  );
};

export default Start;
